import { cn } from '@repo/lib/cn';
import { ArrowLeftIcon, ArrowRightIcon, CheckCircle2 } from 'lucide-react';

import type { QuizNavigationReturnType } from '@/hooks/quiz';

import { Button } from '@/components/ui/button';
import { LoadingSwap } from '@/components/ui/loading-swap';

interface BottomNavigationProps {
  currentSection: number;
  totalSections: number;
  freeNavigation: boolean;
  instantMark: boolean;
  showMarked: boolean;
  actions: QuizNavigationReturnType['actions'];
  state: QuizNavigationReturnType['state'];
}

export default function BottomNavigation(bottomNavigationProps: BottomNavigationProps) {
  const { currentSection, totalSections, freeNavigation, actions, state, instantMark, showMarked } = bottomNavigationProps;

  const isLastSection: boolean = currentSection >= totalSections - 1;
  const canNavigatePrevious: boolean = currentSection > 0 && freeNavigation;
  const canNavigateNext: boolean = !isLastSection || (!freeNavigation && !isLastSection);
  const canSubSubmit: boolean = instantMark && !showMarked;

  return (
    <div className="flex justify-end gap-3 p-4">
      {freeNavigation && (
        <Button variant={'tertiary'} className={cn('w-fit', !canNavigatePrevious && 'hidden')} onClick={actions.onNavigatePrevious} disabled={!canNavigatePrevious}>
          <ArrowLeftIcon />
          <span className="sr-only sm:not-sr-only">Poprzednie</span>
        </Button>
      )}
      {canSubSubmit && (
        <Button type={'button'} variant={'tertiary'} className={'w-full sm:w-fit'} onClick={actions.onSubSubmit} disabled={state.isPending}>
          <LoadingSwap isLoading={state.isPending} className="flex items-center gap-2">
            Oceń <CheckCircle2 />
          </LoadingSwap>
        </Button>
      )}
      {canNavigateNext && (
        <Button type={'button'} variant={'secondary'} className={'w-full sm:w-fit'} onClick={actions.onNavigateNext}>
          Następne
          <ArrowRightIcon />
        </Button>
      )}
      {isLastSection && (
        <Button variant={'primary'} className={'w-full sm:w-fit'} onClick={actions.onSaveAndSubmit} disabled={state.isPending || state.isFinishing}>
          <LoadingSwap isLoading={state.isPending || state.isFinishing} className="flex items-center gap-2">
            Zakończ <CheckCircle2 />
          </LoadingSwap>
        </Button>
      )}
    </div>
  );
}
